import { Fragment } from "react";
import { object } from "prop-types";
import { observer } from "mobx-react";
import { BreakdownColumns, DescriptionModes } from "@repo/utils";
import { useEstimateStructure, useEstimateTableSettings } from "@tools";
import {
  TaskDescriptionCell,
  TaskLabelsCell,
  TaskMaterialsCell,
  TaskPriceCell,
  TaskTitleCell,
  TaskEstimatesCell,
} from "./cells";

export const ColumnFactory = observer(({
  children,
  section,
}) => {
  const structure = useEstimateStructure();
  const { lastPinnedCellLeft, displayColumns } = useEstimateTableSettings();
  
  const { showBreakdownColumns, descriptionMode } = structure.settings;
  
  return <>
    {
      displayColumns.map((column, index, columns) => {
        const props = {
          extendPadding: index === columns.length-1,
          columnSettings: column,
          section,
        };
        const pinnableCellProps = {
          isLastPinnedCell: lastPinnedCellLeft === column.id,
          isLastPinnableCell: !columns[index+1] || (columns[index+1].isVisible && !columns[index+1].pinnable),
        };
        
        switch (column.name) {
          // case BreakdownColumns.NUMERATION:
          //   return <TaskNumeration {...cellProps} />;
          
          case BreakdownColumns.TITLE:
            return <TaskTitleCell
              key={column.id}
              {...pinnableCellProps}
              {...props}
            >
              { children }
            </TaskTitleCell>;
          
          case BreakdownColumns.LABELS:
            return <TaskLabelsCell
              key={column.id}
              {...pinnableCellProps}
              {...props}
            />;
          
          case BreakdownColumns.DESCRIPTION:
            if(descriptionMode !== DescriptionModes.COLUMN)
              return <></>;
            return <TaskDescriptionCell
              key={column.id}
              {...pinnableCellProps}
              {...props}
            />;
          
          case BreakdownColumns.ESTIMATES:
            if(!showBreakdownColumns)
              return;
            
            if(section.materialFirst)
              return <TaskMaterialsCell
                key={column.id}
                section={section}
              />
            
            return <TaskEstimatesCell
              key={column.id}
              // extendPadding={index === columns.length-1}
              section={section}
            />;
          
          case BreakdownColumns.PRICE:
            return <TaskPriceCell
              key={column.id}
              {...props}
            />;
        }
      })
    }
  </>
})

ColumnFactory.propTypes = {
  section: object.isRequired,
};
